var alpha = {
    0: '00',
    5: '0D',
    10: '1A',
    15: '26',
    35: '59',
    50: '80',
    60: '99',
};
var colors = {
    primary: '#52CF29',
    primaryLighten: '#82DC64',
    primaryDarken: '#43A721',
    primaryDisabled: '#BAECA9',
    white: '#fff',
    gray0: '#FFFFFF',
    gray1: '#f8f9fa',
    gray2: '#f1f3f5',
    gray3: '#dee2e6',
    gray4: '#adb5bd',
    gray5: '#868e96',
    gray6: '#212529',
    info: '#548fcc',
    danger: '#FF5848',
    dangerLighten: '#FF7063',
    dangerDarken: '#E54F40',
    dangerDisabled: '#ffbcb6',
    warning: '#f2ba53',
    success: '#3bd569',
};
var brandColors = {
    light: {
        default: '#52CF29',
        hover: '#82DC64',
        pressed: '#43A721',
        disabled: '#BAECA9',
    },
    dark: {
        default: '#1DD844',
        hover: '#56E273',
        pressed: '#17AD36',
        disabled: '#1F6D34',
    },
};
var scales = {
    black: '#16191C',
    white: '#FFFFFF',
    gray5: '#F8F9FA',
    gray10: '#F1F3F5',
    gray15: '#DEE2E6',
    gray20: '#ADB5BD',
    gray30: '#868E96',
    gray40: '#6D757E',
    gray50: '#5F666D',
    gray60: '#51575C',
    gray70: '#3B4044',
    gray80: '#31363A',
    gray90: '#212529',
    blue5: '#ECF6FE',
    blue10: '#BBDEFB',
    blue20: '#90C9F9',
    blue30: '#63B4F6',
    blue40: '#42A4F5',
    blue50: '#2196F3',
    blue60: '#1F87E5',
    blue70: '#1A75D2',
    blue80: '#1661BA',
    blue90: '#0F439C',
    green5: '#E6F9EA',
    green10: '#C3F0CB',
    green20: '#9BE7AA',
    green30: '#6BDE86',
    green40: '#3BD569',
    green50: '#00CC4B',
    green60: '#00BC41',
    green70: '#00A934',
    green80: '#008C24',
    green90: '#007011',
    orange5: '#FEF3E0',
    orange10: '#FEDFB2',
    orange20: '#FDCB80',
    orange30: '#FCB64D',
    orange40: '#FCA626',
    orange50: '#FB9600',
    orange60: '#F78B00',
    orange70: '#F17B00',
    orange80: '#DB6300',
    orange90: '#C94800',
    red5: '#FFF0F2',
    red10: '#FFBDBD',
    red20: '#FF9794',
    red30: '#FF7F7A',
    red40: '#F8635F',
    red50: '#FF5848',
    red60: '#EF4E46',
    red70: '#DD443F',
    red80: '#B53631',
    red90: '#8C2721',
    transparentWhite0: "#FFFFFF" + alpha[0],
    transparentWhite5: "#FFFFFF" + alpha[5],
    transparentWhite10: "#FFFFFF" + alpha[10],
    transparentWhite15: "#FFFFFF" + alpha[15],
    transparentWhite35: "#FFFFFF" + alpha[35],
    transparentWhite50: "#FFFFFF" + alpha[50],
    transparentWhite60: "#FFFFFF" + alpha[60],
    transparentBlack0: "#000000" + alpha[0],
    transparentBlack5: "#000000" + alpha[5],
    transparentBlack10: "#000000" + alpha[10],
    transparentBlack15: "#000000" + alpha[15],
    transparentBlack35: "#000000" + alpha[35],
    transparentBlack50: "#000000" + alpha[50],
    transparentBlack60: "#000000" + alpha[60],
};

export { brandColors, colors, scales };
